import React from 'react'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'

interface CompanyNonBankingApplicationRecordsOverviewProps {
  data: any
}

export default function CompanyNonBankingApplicationRecordsOverview({
  data,
}: CompanyNonBankingApplicationRecordsOverviewProps) {
  const theme = useTheme()

  const yearTotalCount = Number(data?.nb_m12_apply_count) || 0
  const yearTotalOrgs = Number(data?.nb_m12_apply_org_count) || 0
  const week7Count = Number(data?.nb_d7_apply_count) || 0

  const getActivityLevel = () => {
    if (yearTotalCount === 0) return '无申请记录'
    if (week7Count === 0) return '近期无申请'
    const ratio = (week7Count / yearTotalCount) * 100
    if (ratio > 10) return '活跃'
    if (ratio > 5) return '较活跃'
    return '一般'
  }

  const activityLevel = getActivityLevel()

  return (
    <div className="mt-2">
      <Stack gap="md">
        <div className="flex flex-col gap-2">
          <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
            企业非银行申请概览
          </Text>
          <Text size="xs" className="text-gray-500">
            汇总企业非银行机构贷款申请的整体情况,包括申请次数、机构数量及活跃度评估。
          </Text>
        </div>
        <div className="grid gap-3 md:grid-cols-3">
          <SummaryItem label="近1年申请总次数" value={`${yearTotalCount} 次`} subtitle="所有非银行机构" />
          <SummaryItem label="近1年申请机构数" value={`${yearTotalOrgs} 家`} subtitle="去重统计" />
          <SummaryItem
            label="近7天申请活跃度"
            value={activityLevel}
            subtitle={week7Count > 0 ? `近7天 ${week7Count} 次` : '近期无申请'}
          />
        </div>
      </Stack>
    </div>
  )
}

interface SummaryItemProps {
  label: string
  value: string
  subtitle?: string
}

function SummaryItem({ label, value, subtitle }: SummaryItemProps) {
  const theme = useTheme()

  return (
    <div
      className="rounded-lg border px-4 py-3"
      style={{ borderColor: theme.surfaceBorderColor, backgroundColor: theme.surfaceColor }}
    >
      <Text size="xs" className="text-gray-500">
        {label}
      </Text>
      <Text size="sm" fw={600} style={{ marginTop: '6px', color: theme.primaryColor }}>
        {value}
      </Text>
      {subtitle && (
        <Text size="xs" className="text-gray-400" style={{ marginTop: '4px' }}>
          {subtitle}
        </Text>
      )}
    </div>
  )
}
